import { useEffect, useState } from 'react'

import { makeTraceDetails } from 'common'
import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'

export function useDisableAllNotificationsContent({ type }: { type: 'success' | 'confirm' }) {
  const { privacyCenterContent, isAppLoading, isAppError } = useAppContext()

  const confirmDisableAllCommunicationsBottomsheet =
    privacyCenterContent?.components?.confirmDisableAllCommunicationsBottomsheet

  const successDisableAllCommunicationsBottomsheet =
    privacyCenterContent?.components?.successDisableAllCommunicationsBottomsheet

  const { content, isActive } =
    type === 'success'
      ? successDisableAllCommunicationsBottomsheet || { content: undefined, isActive: false }
      : confirmDisableAllCommunicationsBottomsheet || { content: undefined, isActive: false }

  const [errorOrInactive, setErrorOrInactive] = useState(false)

  const [traceDetails, setTraceDetails] = useState('')

  useEffect(() => {
    const isErrorOrInactive = isAppError || isEmpty(content) || !isActive
    if (isErrorOrInactive !== errorOrInactive) setErrorOrInactive(isErrorOrInactive)

    if (isErrorOrInactive) {
      setTraceDetails(makeTraceDetails(isActive, content))
    }
  }, [content, errorOrInactive, isActive, isAppError])

  return { ...content, isActive, errorOrInactive, traceDetails, isAppLoading }
}
